import React, { useEffect } from 'react';

import { useFilters } from '@/utils';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportDetailsProps, ReportTab, ReportTypeKeys } from '../../report.types';
import { useGetReportEmployerId } from '../hooks';
import ReportDetailsBase from '../ReportDetailsBase';

import { EmployeeDemographicsReportTableParams } from './EmployeeDemographicsReport.types';
import EmployeeDemographicsReportSummary from './EmployeeDemographicsReportSummary';
import EmployeeDemographicsReportTable from './EmployeeDemographicsReportTable';

type FiltersValues = EmployeeDemographicsReportTableParams & {
  tab: ReportTab;
};

const TEST_ID = 'employee-demographic-report-details';

interface Props extends ReportDetailsProps<FiltersValues> {}
const EmployeeDemographicsReportDetails: React.FC<Props> = ({
  defaultEmployerId,
  defaultEmployerIds,
  defaultTab,
  isPreviewMode,
  onChangeFilters,
  defaultFilterValues,
}) => {
  const employerId = useGetReportEmployerId();
  const { filtersValues, setFilterValue } = useFilters<FiltersValues>(
    {
      employerId: defaultEmployerId || employerId,
      employerIds: defaultEmployerIds || employerId ? [employerId] : [],
      searchString: '',
      isSSNShowed: false,
      employmentStatuses: [],
      ...defaultFilterValues,
      tab: defaultTab || ReportTab.Report,
    },
    {
      disabled: isPreviewMode,
      autoClear: true,
    }
  );
  useEffect(() => {
    if (employerId && !filtersValues.employerId) {
      setFilterValue.employerId(employerId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employerId]);
  useEffect(() => {
    if (defaultTab) {
      setFilterValue.tab(defaultTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultTab]);

  useEffect(() => {
    if (isPreviewMode && onChangeFilters) {
      onChangeFilters(filtersValues);
    }
  }, [filtersValues, isPreviewMode, onChangeFilters]);
  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.EmployeeDemographic);
  return (
    <ReportDetailsBase
      isPreviewMode={isPreviewMode}
      testId={TEST_ID}
      isFavorite={isFavorite}
      onToggleFavorite={handleToggleReportKey}
      tab={filtersValues.tab}
      isNoSummaryMode
      onSetTab={setFilterValue.tab}
      title="Employee Demographics"
    >
      {filtersValues.tab === ReportTab.Report ? (
        <EmployeeDemographicsReportTable
          defaultEmployerId={defaultEmployerId}
          isPreviewMode={isPreviewMode}
          key={filtersValues.tab}
          filtersValues={filtersValues}
          onSetFilterValue={setFilterValue}
        />
      ) : (
        <EmployeeDemographicsReportSummary isPreviewMode={isPreviewMode} />
      )}
    </ReportDetailsBase>
  );
};

export default EmployeeDemographicsReportDetails;
